import React, { useEffect, useState } from 'react';

import { Button, Dimmer, Dropdown, Flag, Form, Grid, Input, Loader } from 'semantic-ui-react';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
    errorSelector,
    getLoginPageRequest,
    isAuthSelector,
    loginPageSelector,
    loginRequest,
    progressSelector,
} from '../../ducks/login';
import languages from '../../constants/languages';
import logo from '../../icons/svg/logo.svg';
import './style.scss';

const Login = ({ history }) => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const page = useSelector(state => loginPageSelector(state)) || {};
    const isAuth = useSelector(state => isAuthSelector(state));
    const error = useSelector(state => errorSelector(state));
    const loginProgress = useSelector(state => progressSelector(state, 'login_progress'));
    const pageLoadingProgress = useSelector(state => progressSelector(state, 'page_progress'));
    const { form: formElements = {} } = page;
    const { inputs = [], login_btn = {} } = formElements;

    const [form, setForm] = useState({});

    const [showNewYearTheme, setShowNewYearTheme] = useState(false);

    useEffect(() => {
        dispatch(getLoginPageRequest());

        if (isAuth) history.replace('/');

        const currentDate = new Date();
        const endDate = new Date('2026-01-11T23:59:59');
        setShowNewYearTheme(currentDate <= endDate);
    }, []);

    const handleChange = (e, { name, value }) => {
        const values = {
            ...form,
            [name]: value,
        };
        setForm(values);
    };

    const handleChangeLang = (e, { value }) => {
        i18n.changeLanguage(value);
    };

    const handleFormSubmit = (e, { api }) => {
        const params = {
            form: {
                ...form,
                language: i18n.language,
            },
            api: login_btn.api,
        };
        dispatch(loginRequest(params));
    };

    return (
        <>
            {showNewYearTheme && (
                <div className="login-page-background"></div>
            )}
            <Dimmer inverted active={pageLoadingProgress}>
                <Loader inverted>Loading</Loader>
            </Dimmer>
            {!isAuth ? (
                <>
                    <div className="centered-div">
                        <Grid className="login-form-wrapper">
                            <Grid.Row>
                                <Grid.Column className="login-form-description">
                                    <div>
                                        <img src={logo} alt={'LOGO'} />
                                    </div>        
                                    <div>
                                        <p className="login-form-description-company">
                                            {t(page.name)}
                                        </p>
                                        <p>{t(page.support_name)}</p>
                                    </div>
                                </Grid.Column>
                                <Grid.Column className="login-form-input-wrapper">
                                    <Form autoComplete='off' onSubmit={handleFormSubmit}>
                                        {inputs.map(input => (
                                            <div className="margin-bottom-10" key={input.name}>
                                                <Input
                                                    autoComplete={input.type === 'password' && "new-password"}
                                                    icon={input.icon}
                                                    iconPosition="left"
                                                    name={input.name}
                                                    value={form[input.name]}
                                                    placeholder={t(input.name)}
                                                    type={input.type}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        ))}
                                        <Button 
                                            className={page.loginSsoUrl && "margin-bottom-10"}
                                            floated="right"
                                            primary
                                            api={login_btn.api}
                                            loading={loginProgress}
                                        >
                                            {t(login_btn.name)}
                                        </Button>
                                        {page.loginSsoUrl && (
                                            <div>
                                                <a
                                                    className="ui right floated button"
                                                    href={page.loginSsoUrl}
                                                >
                                                    {page.loginSsoName}
                                                </a>
                                            </div>
                                        )}
                                        <div className="login-error">{t(error)}</div>
                                    </Form>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </div>
                    <div className="language-switcher">
                        <Flag
                            name={
                                languages.find(item => item.value === i18n.language) &&
                                languages.find(item => item.value === i18n.language).flag
                            }
                        />{' '}
                        <Dropdown
                            inline
                            options={languages}
                            value={i18n.language}
                            onChange={handleChangeLang}
                        />
                    </div>
                    <div className="support-info">
                        <a href="mailto:support.napitkivmeste@artlogics.me">support.napitkivmeste@artlogics.me</a>
                        <div>{t("support_work_time")}</div>
                    </div>
                </>
            ) : null}
        </>
    );
};

export default Login;
